import styled from 'styled-components';

export const CaseStudiesWrapper = styled.section`
  padding: 80px 0;
  background: #f9fbfd;
  @media (max-width: 990px) {
    padding: 60px 0;
  }
  @media (max-width: 767px) {
    padding: 40px 0;
  }
`;

export const Intro = styled.p`
  max-width: 640px;
  margin: 10px auto 0;
  text-align: center;
  font-size: 17px;
  line-height: 1.6;
  color: #343d48;
`;

/* Five cards: three on wide screens (the last two centred under them), two on
   tablets, one on phones. */
export const CardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  margin-top: 20px;
  @media (max-width: 767px) {
    gap: 20px;
  }
`;

export const Card = styled.article`
  display: flex;
  flex-direction: column;
  flex: 1 1 320px;
  max-width: calc((100% - 60px) / 3);
  background: #fff;
  border-radius: 10px;
  padding: 34px 30px 28px;
  box-shadow: 0 8px 30px rgba(15, 33, 55, 0.08);

  @media (max-width: 1099px) {
    max-width: calc((100% - 30px) / 2);
  }
  @media (max-width: 767px) {
    max-width: none;
    padding: 28px 24px 22px;
  }

  .amount {
    display: block;
    font-size: 36px;
    font-weight: 700;
    color: #0f2137;
    letter-spacing: -0.025em;
    line-height: 1.15;
    margin-bottom: 8px;
    @media (max-width: 767px) {
      font-size: 30px;
    }
  }

  .amount-label {
    display: block;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #46679f;
    margin-bottom: 16px;
  }

  p {
    font-size: 16px;
    color: #343d48;
    line-height: 1.7;
    margin: 0;
  }

  /* what the app finds, set apart at the foot of the card */
  .in-app {
    margin-top: auto;
    padding-top: 16px;
    border-top: 1px solid #e3e9f2;
    font-size: 15px;
    line-height: 1.6;
    color: #343d48;
    b {
      color: #0f2137;
    }
  }
  p + .in-app {
    margin-top: 18px;
  }
  /* the story grows, the app line stays at the foot */
  p:not(.in-app) {
    flex: 1 0 auto;
  }
`;

/* The bill from one project: a card wider than the case grid, so the
   screenshot from CloudPouch (1646 x 487, its text about 16 px) shows with
   text of about 12 px on desktop. The headline, the difference and the quote
   carry the figures in text above it, so on phones, where the screenshot is
   small, nothing depends on reading it; a click opens it full size. */
export const ChartCard = styled.article`
  width: min(1280px, calc(100% - 60px));
  margin: 30px auto 0;
  padding: 36px 24px 26px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 30px rgba(15, 33, 55, 0.08);
  scroll-margin-top: 94px;

  @media (max-width: 1199px) {
    scroll-margin-top: 63px;
  }
  @media (max-width: 767px) {
    padding: 28px 12px 20px;
  }

  .chart-copy {
    display: grid;
    grid-template-columns: minmax(0, 5fr) minmax(0, 6fr);
    align-items: start;
    gap: 40px;
    padding: 0 16px;
    @media (max-width: 899px) {
      grid-template-columns: 1fr;
      gap: 18px;
    }
    @media (max-width: 767px) {
      padding: 0 12px;
    }
  }

  h3 {
    margin: 0 0 10px;
    font-size: 30px;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.02em;
    color: #0f2137;
    @media (max-width: 767px) {
      font-size: 26px;
    }
  }

  .chart-diff {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #1f7a4a;
  }

  blockquote {
    margin: 0;
    p {
      margin: 0;
      font-size: 17px;
      line-height: 1.65;
      color: #343d48;
    }
    footer {
      margin-top: 12px;
      font-size: 15px;
      font-weight: 600;
      color: #46679f;
    }
  }

  .chart-shot {
    margin: 28px 0 0;

    /* the chart takes 80% of the card, centred; the caption keeps the full
       width */
    a {
      display: block;
      width: 80%;
      margin: 0 auto;
      border-radius: 6px;
      &:focus-visible {
        outline: 2px solid #46679f;
        outline-offset: 3px;
      }
    }

    img {
      display: block;
      width: 100%;
      height: auto;
    }

    figcaption {
      margin-top: 12px;
      padding: 0 16px;
      font-size: 15px;
      line-height: 1.5;
      color: #5d646d;
      @media (max-width: 767px) {
        padding: 0 12px;
      }
    }
  }
`;

/* After the proof: one line and the download button, centred. */
export const CaseCta = styled.div`
  margin: 44px auto 0;
  text-align: center;

  p {
    margin: 0 0 18px;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.4;
    color: #0f2137;
  }

  > a {
    display: inline-block;
  }

  @media (max-width: 767px) {
    margin-top: 32px;
    p {
      font-size: 18px;
    }
    > a,
    button {
      width: 100%;
    }
  }
`;

export const Footnote = styled.p`
  max-width: 820px;
  margin: 35px auto 0;
  text-align: center;
  font-size: 15px;
  color: #5d646d;
  line-height: 1.6;
`;
